
























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { countryList } from "@/lib/countryList";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import FormatMoney from "@/components/FormatMoney";
import BillingDetailsForm from "../BillingDetailsForm";
import CardDetailsForm from "../CardDetailsForm";
import PaymentSystemLogo from "../PaymentSystemLogo";

@Component({
  name: "CardEditView",
  components: {
    BaseCheckbox,
    CardDetailsForm,
    BillingDetailsForm,
    PaymentSystemLogo,
    BasePage,
    BaseIcon,
    BaseButton,
    FormatMoney,
  },
})
export default class CardEditView extends Vue {
  @Prop({ type: Boolean, required: true })
  public readonly loading!: boolean;

  @Prop({ type: String, default: "/img/cards/netbilling/systems.png" })
  public paymentSystemLogoSrc!: string;

  @Prop({ type: Boolean, default: false })
  public isSubscription!: boolean;

  @Prop({ type: String })
  public price!: string | undefined;

  public formValidators: (() => {})[] = [];

  public cardValid: boolean = false;

  public billingValid: boolean = false;

  public cardDetailsValues: FormValues = {};

  public billingDetailsValues: FormValues = {
    country: countryList[0].code,
  };

  public tcAgree: boolean = false;

  public saveCard: boolean = this.isSubscription || false;

  public get companyName() {
    return config.companyName;
  }

  public get companyAddress() {
    return config.companyAddress;
  }

  public get buttonText() {
    let text = $t("Purchase");
    if (this.isSubscription) {
      text = $t("Subscribe");
    }
    return this.price ? $t("{0} for {1}", [text, this.price]) : text;
  }

  public setFormValidators(validator: () => {}) {
    this.formValidators.push(validator);
  }

  public onSubmit() {
    this.formValidators.forEach(c => c());
    if (!this.tcAgree || !this.cardValid || !this.billingValid) return;
    this.$emit("submit", {
      cardDetails: this.cardDetailsValues,
      billingDetails: this.billingDetailsValues,
      saveCard: this.saveCard,
    });
  }
}
